import BNB from './BNB';
import BTC from './BTC';
import ETH from './ETH';
import LTC from './LTC';
import TON from './TON';
import TRX from './TRX';
import USDC_ERC20 from './USDC_ERC20';
import USDT_BEP20 from './USDT_BEP20';
import USDT_ERC20 from './USDT_ERC20';
import USDT_TON from './USDT_TON';
import USDT_TRC20 from './USDT_TRC20';
import CashApp from './CashApp';
import CashApp_Merchant from './CashApp_Merchant';
import Cards from './Cards';
import OnlineBanking from './OnlineBanking';
import Chime from './Chime';
import Zelle from './Zelle';
import CashApp_P2P from './CashApp_P2P';
import ApplePay from './ApplePay';
import GooglePay from './GooglePay';
import Crypto from './Crypto';
import PayPal from './PayPal';

export default {
    ApplePay,
    GooglePay,
    CashApp,
    CashApp_Merchant,
    CashApp_P2P,
    Cards,
    OnlineBanking,
    Chime,
    Zelle,
    BNB,
    BTC,
    ETH,
    LTC,
    TON,
    TRX,
    USDC_ERC20,
    USDT_BEP20,
    USDT_ERC20,
    USDT_TON,
    USDT_TRC20,
    Crypto,
    PayPal
}